<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="payroll.setup.payrollSetup" [menuService]="payrollModuleMenuService">
        <div class="buttons">
            <a href="https://humi.zendesk.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer">
                {{ 'payroll.setup.contactSupport' | translate }}
            </a>
        </div>
    </app-header>
    <div class="ui segment">
        <app-self-onboarding-company-information-form
            #companyInformationForm
            (loading)="isLoading = $event"
            (editing)="isEditing = $event"
        ></app-self-onboarding-company-information-form>
    </div>
</div>
